import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useNavigate, useLocation } from 'react-router-dom';
import { Outlet } from 'react-router-dom';

export default function LerCSV() {
    const navigate = useNavigate();
    const location = useLocation();

    // Determina o valor da aba com base no caminho atual da URL
    let value = 0;
    if (location.pathname.endsWith('/dashboard-periodo')) {
        value = 1;
    }
    if (location.pathname.endsWith('/dashboard-vendas-dia')) {
        value = 2;
    } 
    
    // Se a rota for '/producao/gerar', o valor padrão (0) é mantido.

    const handleChange = (event, newValue) => {
        if (newValue === 0) {
            navigate('/dashboard/dashboard-diario');
        } else if (newValue === 1) {
            navigate('/dashboard/dashboard-periodo');
        } else if (newValue === 2) {
            navigate('/dashboard/dashboard-vendas-dia');
        }
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChange} aria-label="Abas de Cupons">
                    <Tab label="Dashboard Diario" />
                    <Tab label="Dashboard Periodo" />
                    <Tab label="Dashboard Vendas Dia" />
                </Tabs>
            </Box>
            {/* O Outlet renderizará o conteúdo do componente da rota aninhada */}
            <Outlet />
        </Box>
    );
}